module.exports = __webpack_public_path__ + "static/media/Avatars_Other-21.4d81292f.png";